import request from "@/utils/request";

//任务列表
export const getPrepareJobsAPageList = async (body: any): Promise<any> => {
  const url = `/uav/job/getList`;
  const result = await request.post(url, body);
  return result.data;
};

//航线列表
export const getWayLineList = async (body: any): Promise<any> => {
  const url = `uav/wayline/getWayLineList`;
  const result = await request.post(url, body);
  return result.data;
};

//航线详情
export const getWayLineInfo = async (waylineId: any): Promise<any> => {
  const url = `/uav/wayline/info/` + waylineId;
  const result = await request.get(url);
  return result.data;
};

//事件列表
export const getAlarmList = async (body: any, axiosConfig?: { signal?: AbortSignal }): Promise<any> => {
  const url = `/uav/event/all`;
  const result = await request.post(url, body, axiosConfig);
  return result.data;
};

//事件删除
export const deleteAlarmList = async (warningId: any): Promise<any> => {
  const url = `/uav/event/delete/` + warningId;
  const result = await request.get(url, {});
  return result.data;
};

//事件推送
export const sendAlarmList = async (body: any): Promise<any> => {
  const url = `/uav/event/pushEvent`;
  const result = await request.post(url, body);
  return result.data;
};

//预警航线统计
export const getWaylineStatistic = async (body: any): Promise<any> => {
  const url = `/uav/screen/statisticByWayline`;
  const result = await request.post(url, body);
  return result.data;
};

//任务列表统计
export const getJobStatistic = async (body: any): Promise<any> => {
  const url = `/uav/screen/statisticByJob`;
  const result = await request.post(url, body);
  return result.data;
};

/**
 * 媒体管理列表
 *
 * @param data
 */
export const getMediaList = async (body: any): Promise<any> => {
  const url = `/uav/media/file/getFileList`;
  const result = await request.post(url, body);
  return result.data;
};

/**
 * 手动添加事件
 *
 * @param data
 */
export const addFlightLogEvent = async (body: any): Promise<any> =>  {
  const url = `/uav/event/addFlightLogEvent`;
  const result = await request.post(url, body);
  return result.data;
}
